export default "__VITE_ASSET__j1ojwUfU__"